import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeftSharp';
import ChevronRightIcon from '@material-ui/icons/ChevronRightSharp';
import { useIntl } from 'react-intl';

const useStyles = makeStyles(theme => ({
  previousButton: {
    margin: theme.spacing(-1, 0, -1, -1.5),
    paddingRight: `${theme.spacing(0.25)}px`,
    borderTopRightRadius: '25%',
    borderBottomRightRadius: '25%',
    [theme.breakpoints.down('sm')]: {
      padding: 0
    }
  },
  nextButton: {
    margin: theme.spacing(-1, 0.5, -1, 0),
    paddingLeft: `${theme.spacing(0.25)}px`,
    borderTopLeftRadius: '25%',
    borderBottomLeftRadius: '25%',
    [theme.breakpoints.down('sm')]: {
      padding: 0
    }
  }
}));

export const ChevronLeftDateButton = ({
  dataQedId,
  onClick,
  disabled,
  className,
  autoFocus
}) => {
  const intl = useIntl();

  return (
    <IconButton
      data-qe-id={dataQedId}
      className={className}
      aria-label={intl.formatMessage({ id: 'dateButton.previous' })}
      onClick={onClick}
      disabled={disabled}
      autoFocus={autoFocus}
    >
      <ChevronLeftIcon mirror="rtl" />
    </IconButton>
  );
};

ChevronLeftDateButton.propTypes = {
  dataQedId: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  autoFocus: PropTypes.bool
};

export const ChevronRightDateButton = ({
  dataQedId,
  onClick,
  disabled,
  className
}) => {
  const intl = useIntl();

  return (
    <IconButton
      data-qe-id={dataQedId}
      className={className}
      aria-label={intl.formatMessage({ id: 'dateButton.next' })}
      onClick={onClick}
      disabled={disabled}
    >
      <ChevronRightIcon mirror="rtl" />
    </IconButton>
  );
};

ChevronRightDateButton.propTypes = {
  dataQedId: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string
};

export const ChevronDateButtons = ({
  onPreviousClick,
  onNextClick,
  disableLeftButton = false,
  disableRightButton = false,
  classes: classesOverride,
  autoFocus
}) => {
  const classes = useStyles({ classes: classesOverride });

  return (
    <>
      <ChevronLeftDateButton
        dataQedId="PreviousPeriodArrow"
        className={classes.previousButton}
        onClick={onPreviousClick}
        disabled={disableLeftButton}
        autoFocus={autoFocus}
      />
      <ChevronRightDateButton
        dataQedId="NextPeriodArrow"
        className={classes.nextButton}
        onClick={onNextClick}
        disabled={disableRightButton}
      />
    </>
  );
};

ChevronDateButtons.propTypes = {
  onPreviousClick: PropTypes.func.isRequired,
  onNextClick: PropTypes.func.isRequired,
  disableLeftButton: PropTypes.bool,
  disableRightButton: PropTypes.bool,
  classes: PropTypes.object,
  autoFocus: PropTypes.bool
};

export default ChevronDateButtons;
